import { ChampionshipEditTab } from 'modules/championship/domain/enums/championship-edit-tab';
import { ChampionshipSettings } from 'modules/championship/domain/interfaces/championship-settings';

/**
 * Вкладки, для которых нужна заполненная и сохранённая заявочная кампания
 * («Параметры» → «Заявочная кампания»): без дат приёма заявок и лимитов состава
 * заявки, этапы и сборные нечем наполнять.
 */
const TABS_REQUIRING_APPLICATION_CAMPAIGN: string[] = [
  ChampionshipEditTab.TEAMS,
  ChampionshipEditTab.STEPS,
  ChampionshipEditTab.SYMBOLIC_TEAMS,
];

/**
 * Заявочная кампания считается настроенной, когда все её поля заполнены и
 * сохранены. «Переходы возможны» в проверку не входит — это флаг с валидным
 * значением по умолчанию (`false`), а не незаполненное поле.
 */
export const isApplicationCampaignConfigured = (settings: ChampionshipSettings | null | undefined): boolean => {
  if (!settings) {
    return false;
  }

  return (
    Boolean(settings.applicationStartDate) &&
    Boolean(settings.applicationEndDate) &&
    settings.applicationMinPlayers !== null &&
    settings.applicationMaxPlayers !== null &&
    settings.participationFee !== null
  );
};

/**
 * Доступна ли вкладка редактирования соревнования.
 *
 * Читают двое: `ChampionshipEditFormTabs` — чтобы погасить вкладку в табах, и
 * роутер (`edit-form.tsx`) — чтобы увести с прямого адреса, если зайти по ссылке
 * в обход табов.
 */
export const isChampionshipEditTabAvailable = (settings: ChampionshipSettings | null | undefined, tab: string): boolean => {
  if (!TABS_REQUIRING_APPLICATION_CAMPAIGN.includes(tab)) {
    return true;
  }

  return isApplicationCampaignConfigured(settings);
};
